import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import PipelineSection from './components/PipelineSection';
import WidgetDemoSection from './components/WidgetDemoSection';
import DeveloperSection from './components/DeveloperSection';
import AnalyticsSection from './components/AnalyticsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <PipelineSection />
      <WidgetDemoSection />
      <DeveloperSection />
      <AnalyticsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mitvegyekai" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
